import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useConfig } from "../utils/ConfigContext.jsx";
import { createAxiosInstance } from "../utils/AxiosInstance.jsx";
import { set } from "date-fns";

const ForgotPasswordLayer = () => {
    const { API_BASE_URL } = useConfig();
    const AxiosInstance = createAxiosInstance(API_BASE_URL);


    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showModal, setShowModal] = useState(false);

    const handleSubmit =  async (e) => {
        e.preventDefault();
        setError("");

        

        if (!email) {
            setError("Email is required");
            return;
        }

        try {
            setLoading(true);

            await AxiosInstance.post("/forgot-password", {
                email,
            });
            // Open modal manually after success
            setShowModal(true);


        } catch (err) {
            setError(
                err.response?.data?.message ||
                "Unable to send reset link. Try again later."
            );
        } finally {
            setLoading(false);
        }


    };

    return (
        <>
            <section className="auth forgot-password-page bg-base d-flex flex-wrap">
                {/* Left Image */}
                <div className="auth-left d-lg-block d-none">
                    <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                        <img src="assets/images/auth/auth-img.png" alt="auth" />
                    </div>
                </div>

                {/* Right Content */}
                <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                    <div className="max-w-464-px mx-auto w-100">
                        <div className="mb-24">
                            <Link to="/" style={{ width: "75px" }}>
                                <img src="assets/images/logo.webp" alt="logo" />
                            </Link>
                            <h4 className="mb-12 mt-12">Forgot Password</h4>
                            <p className="text-secondary-light text-lg">
                                Enter the email address associated with your account and we will send you a link to reset your password.
                            </p>
                        </div>

                        {error && (
                            <div className="alert alert-danger text-sm">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="icon-field mb-3">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="mage:email" />
                                </span>
                                <input
                                    type="email"
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary text-sm px-12 py-16 w-100 radius-12 mt-16"
                                disabled={loading}
                            >
                                {loading ? "Sending..." : "Continue"}
                            </button>

                            <div className="text-center mt-24">
                                <Link to="/" className="text-primary-600 fw-bold">
                                    Back to Sign In
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>

            </section>
             {/* Success Modal */}
            {showModal && (
                <>
                <div className="modal-backdrop fade show h-100 w-100"></div>
                <div
                    className="modal fade show d-block"
                    id="exampleModal"
                    tabIndex={-1}
                    aria-hidden="false"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content radius-16 bg-base">
                            <div className="modal-body p-40 text-center">
                                <div className="mb-32">
                                    <img
                                        src="assets/images/logo.webp"
                                        alt="email sent"
                                    />
                                </div>
                                <h6 className="mb-12">Check your Email</h6>
                                <p className="text-secondary-light text-sm mb-0">
                                    If the email exists, a password reset link has
                                    been sent to it.
                                </p>

                                <Link
                                    to="/"
                                    className="btn btn-primary text-sm px-12 py-16 w-100 radius-12 mt-32"
                                >
                                    Back to Login
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                </>
            )}

            

        </>
    );
};

export default ForgotPasswordLayer;
